<template>
    <span>
        <btn :disabled="dirty" icon="fas fa-envelope" :click="openBillingEmailsModal">Emails</btn>

        <div class="modal fade" :id="'billing-'+billing_period_id+'-email-modal'" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{ editing ? 'Editing Email Template' : 'Emails'}}</h4>
                    </div>
                    <div v-loading="loading" class="modal-body">
                        <textarea :id="'billing-'+billing_period_id+'-email-text'" class="form-control" rows="8" v-model="text"></textarea>
                        <p v-show="editing">
                            <strong>Available shortcodes:</strong>
                            <ul :id="'billing-'+billing_period_id+'-email-shortcodes'"></ul>
                        </p>
                    </div>
                    <div class="modal-footer" style="text-align: center">
                        <button type="button" class="btn" v-if="!editing" @click="editTemplate()" style="float: left">Edit</button>
                        <button type="button" class="btn" v-if="!editing" @click="copyToClipboard()">Copy</button>
                        <button type="button" class="btn" v-if="!editing" style="float: right" data-dismiss="modal">Close</button>

                        <button type="button" class="btn" v-if="editing" style="float: right; margin-left: 20px;" @click="discard()">Discard</button>
                        <btn type="button" v-if="editing" style="float: right" :click="save">Save</btn>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: [
        'billing_period_id'
    ],
    data() {
        return {
            loading: true,
            dirty: false,
            data: null,
            text: '',
            editing: false,
            list: [
                "{client} - will expand into the client's full name (employer_name)",
                "{net} - will expand into net amount",
                "{gross} - will expand into gross amount",
                "{month} - will expand into the Billing Period's month",
            ],
        };
    },
    methods: {
        openBillingEmailsModal() {
            this.editing = false;
            this.refresh();
            $('#billing-'+this.billing_period_id+'-email-modal').modal();
        },
        refresh() {
            this.text = '';
            this.loading = true;
            axios.get(url(`admin/budget-emails/${this.billing_period_id}/email`))
                .then(response => {
                    this.loading = false;
                    this.data = response.data;
                    this.refreshText();
                });
        },
        refreshText() {
            this.text = this.editing ? this.data.template : this.data.text;
        },
        refreshShortCodes() {
            let shortcodes = document.querySelector('#billing-'+this.billing_period_id+'-email-shortcodes');
            if (shortcodes) {
                shortcodes.textContent = '';
                _.forEach(this.list, item => {
                    let info = document.createElement('li');
                    info.textContent = item.replace('employer_name', this.data.client);
                    shortcodes.appendChild(info);
                });
            }
        },
        editTemplate() {
            this.editing = !this.editing;
            this.refreshText();
            this.refreshShortCodes();
        },
        save() {
            this.loading = true;
            return axios.post(url(`admin/budget-emails/email/template/store`), {
                budgetPeriodId: this.billing_period_id,
                template: this.text
            }).then(response => {
                this.loading = false;
                this.data = response.data;
                this.discard();
                this.$message.success('Template saved!');
            });
        },
        discard() {
            this.editing = !this.editing;
            this.refreshText();
        },
        copyToClipboard() {
            let linkObj = document.querySelector('#billing-'+this.billing_period_id+'-email-text');
            linkObj.select();
            linkObj.setSelectionRange(0, 99999);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            this.$message.success('Copied!');
        },
    },
}
</script>
